<template>
  <div>
    <template v-if="$user.id === placement.manager_id && placementStartComponentIsPendingReview">
      <h4>Commentary if amendment required (these comments are not included in the final plan):</h4>
      <div class="form-group mb-2">
        <textarea v-model="newComment"
                  name="comments"
                  class="form-control auto-height"
                  placeholder="Add comments..."
                  v-auto-height>
        </textarea>
      </div>

      <div class="form-group text-right">
        <ladda-button :click="handleSubmitComments" type="button" class="btn btn-sm btn-primary">Send</ladda-button>
      </div>
    </template>

    <template v-if="displayPreviousComments">
      <h4>Previous commentary to graduate:</h4>
      <template v-for="comment in managerComments">
        <article class="border-bottom mt-3" v-bind:key="comment.id">
          <small class="text-muted mb-3 d-block">Added: {{comment.date}} at {{comment.time}}</small>
          <div class="form-group mb-2">
            <p>
              {{comment.content}}
            </p>
          </div>
        </article>
      </template>
      </template>
  </div>
</template>

<script>
import { placementComputed, placementMethods } from 'vx/helpers'
import { helpers } from 'mixins/placements'

export default {
  mixins: [helpers],

  computed: {
    ...placementComputed,
    displayPreviousComments () {
      return this.managerComments.length > 0
    }
  },

  data () {
    return {
      newComment: null,
      managerComments: []
    }
  },

  created () {
    this.getComments()
  },

  methods: {
    ...placementMethods,
    async getComments () {
      await this.getStartPlacementComments({ graduate: this.placement.graduate_id, placement: this.placement.id }).then((response) => {
        this.managerComments = response.data.data
      })
    },
    async handleSubmitComments () {
      let payload = {
        comment: this.newComment
      }
      await this.addStartPlacementComment({ graduate: this.placement.graduate_id, placement: this.placement.id, payload: payload }).then((response) => {
        this.newComment = null
        this.managerComments = response.data.data
        this.$noty.success('Comment has been recorded. <br> The graduate will be notified.')
      })
    }
  }
}
</script>
